import { render, staticRenderFns } from "./AddTodo.vue?vue&type=template&id=6aec1000&scoped=true"
import script from "./AddTodo.vue?vue&type=script&lang=ts"
export * from "./AddTodo.vue?vue&type=script&lang=ts"
import style0 from "./AddTodo.vue?vue&type=style&index=0&id=6aec1000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec1000",
  null
  
)

export default component.exports